import api from '@/api/api';
import { TPrivacy } from './privacy.types';

export const promosEndpoint = 'punter/general/privacy';
export const queryPrivacy = () =>
  api.get<TPrivacy>(promosEndpoint).then((res) => res.data);
